import Permissions from '@/security/permissions';
import PermissionChecker from '@/modules/iam/permission-checker';

export class UserPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.userRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.userImport,
    );
    this.productAutocomplete = permissionChecker.match(
      Permissions.values.userAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.userCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.userEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.userDestroy,
    );
  }
}
